// Auth API — session introspection against the backend function.
// Single hardcoded same-origin mount for the Catalyst session resolver, so this
// and services/api.js's getProfile() resolve /api/auth/me through ONE source of
// truth (no dependence on a build-env var that could be dropped on a deploy).
const BASE = '/server/sessionAPI';

// Same-origin call: `credentials: 'include'` carries the Catalyst session cookie,
// and the platform injects the user's credentials into the function, so the
// backend resolves the user directly (no token).
export async function fetchMe() {
  const res = await fetch(`${BASE}/api/auth/me`, {
    headers: { Accept: 'application/json' },
    credentials: 'include',
  });
  if (!res.ok) {
    const err = new Error(`auth/me ${res.status}`);
    err.status = res.status;
    throw err;
  }
  return res.json(); // { user: { user_id, name, email, role, total_ram_count, ... } }
}
